import { createSlice } from "@reduxjs/toolkit";

const festivalSlice = createSlice({
  name: "festival",
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {
    fetchFestivalRequest: (state) => {
      state.loading = true;
    },
    fetchFestivalSuccess: (state, action) => {
      state.loading = false;
      state.data = action.payload;
    },
    fetchFestivalFail: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const { fetchFestivalRequest, fetchFestivalSuccess, fetchFestivalFail } =
  festivalSlice.actions;

export default festivalSlice.reducer;
